<!--绑定学习卡-->
<template>
  <div>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible="bandShow"
      title="绑定学习卡">
      <p
        style="font-size: 16px;font-weight: bold;margin-top:0px; margin-bottom: 30px; text-align: center;color:#333333;">
        为了您顺利的进行课程学习及证书申请，<span class="c-38bcd5">请绑定学习卡</span></p>
      <el-form ref="formLearnCardRef" :label-position="'top'" :model="formLearnCard" :rules="formLearnCardRules"
        label-width="80px" style="width:320px; margin: 0 auto;">
        <el-form-item label="卡号" prop="cardNum">
          <el-input v-model.trim="formLearnCard.cardNum" placeholder="请输入您的卡号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="cardPass">
          <el-input v-model.trim="formLearnCard.cardPass" placeholder="请输入您的密码" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div class="m0-auto" style="width:100%; text-align: center">
        <el-button type="primary" @click="bindLearnCard()">绑定</el-button>
        <el-button @click="close()">取消</el-button>
      </div>
      <span style="position:absolute; right:5px; top:5px;width:15px; height:15px; cursor:pointer; display:inline-block"
        @click="close()"><img src="../assets/img-4/close.png"></span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :visible.sync="value">
      <p
        style="font-size: 25px;font-weight: bold;margin-top:0px; margin-bottom: 30px; text-align: center;color:#FF1213;">
        您确定将学习卡绑定到该人员账号下？</p>
      <el-form ref="formLearnCardRef" :label-position="'top'" label-width="80px" style="width:320px; margin: 0 auto;">
        <el-form-item>
          <p style="font-size: 15px;font-weight: bold; ">姓 &nbsp;&nbsp; 名：{{ userInfo.realName }}</p>
        </el-form-item>
        <el-form-item>
          <p style="font-size: 15px;font-weight: bold; ">
            证件号：{{ userInfo.sertId.substr(0, 6) }}*****{{ userInfo.sertId.substr(userInfo.sertId.length - 4, userInfo.sertId.length) }}</p>
        </el-form-item>
        <el-form-item>
          <p style="font-size: 15px;font-weight: bold; ">单 &nbsp;&nbsp; 位：{{ userInfo.company.companyName }}</p>
        </el-form-item>
      </el-form>
      <div class="m0-auto" style="width:100%; text-align: center">
        <el-button type="primary" @click="showLearnCardBind()">确定</el-button>
        <el-button @click="closeConfirm()">取消</el-button>
      </div>
      <span style="position:absolute; right:5px; top:5px;width:15px; height:15px; cursor:pointer; display:inline-block"
        @click="closeConfirm()"><img src="../assets/img-4/close.png"></span>
    </el-dialog>
  </div>
</template>

<script>
import { bandLearningCard } from '../api/api'
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    // 使用对象展开运算符将 getters 混入 computed 对象中
    ...mapGetters([
      'userInfo'
      // ...
    ])
  },
  data() {
    return {
      bandShow: false,
      formLearnCard: {
        cardNum: '',
        cardPass: ''
      },
      formLearnCardRules: {
        cardNum: [
          {required: true, message: '请输入学习卡号', trigger: 'blur'}],
        cardPass: [
          {required: true, message: '请输入学习卡密码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    showLearnCardBind() {
      this.bandShow = true
      this.$emit('update:value', false)
      this.$refs.formLearnCardRef.resetFields()
    },
    closeConfirm() {
      this.$emit('update:value', false)
      this.$refs.formLearnCardRef.resetFields()
    },
    bindLearnCard() {
      this.$refs.formLearnCardRef.validate((valid) => {
        if (valid) {
          bandLearningCard({
            cardNumber: this.formLearnCard.cardNum,
            cardPass: this.formLearnCard.cardPass
          }).then((response) => {
            let {data} = response
            if (data.status == 200) {
              this.$message({
                message: data.msg,
                type: 'success'
              })
              if (this.$route.path === '/usercenter/index') {
                window.location.href = '/usercenter'
              }
              this.close()
            } else {
              this.$message(data.msg)
            }
          })
        }
      })
      
    },
    close() {
      this.bandShow = false
    }
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/LearnCardBind.vue